import { RichText } from "components/RichTextWidget";
import { Container, Heading3, Heading5, ImageLite } from "shared/components";

import styles from "./Content041.module.scss";

export const Content041 = ({ payload }) => {
  const title = payload?.title ?? "";
  const image = payload?.preview ?? {};
  const points = payload?.points ?? [];

  return (
    <div className={styles.wrapper}>
      <Container>
        <div className={styles.block}>
          <div className={styles.content}>
            <Heading3 className={styles.title}>{title}</Heading3>
            {points.map(({ id, title, description }) => {
              return (
                <div className={styles.point} key={id}>
                  <Heading5 color="dark" className={styles["point-title"]}>
                    {title}
                  </Heading5>
                  <RichText value={description} />
                </div>
              );
            })}
          </div>
          <span className={styles.preview}>
            <ImageLite image={image} className={styles.image} />
          </span>
        </div>
      </Container>
    </div>
  );
};

export default Content041;
